import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";
import { useLanguage } from "@/i18n/LanguageContext";
import { getLangFromPath } from "@/i18n/routes";

/**
 * Global component inside BrowserRouter that keeps the LanguageContext
 * in sync with the current URL path.
 */
export const LanguageSync = () => {
  const { lang, setLang } = useLanguage();
  const { pathname } = useLocation();

  useEffect(() => {
    const urlLang = getLangFromPath(pathname);
    if (urlLang && urlLang !== lang) {
      setLang(urlLang);
    }
  }, [pathname, lang, setLang]);

  return null;
};
